module.exports = __webpack_public_path__ + "static/img/UnionPay.996af4cc.png";